module.exports = __webpack_public_path__ + "img/gift-mittens.70090dee.svg";